export default __webpack_public_path__ + "static/media/misc.77faf2ba.svg";